import { useEffect, useState } from "react";

import { Link, useParams } from "react-router-dom";

import { getPortfolioById } from "../api";

function PortfolioDetail() {

    const { id } = useParams();

    const [portfolio, setPortfolio] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        async function fetchDetail() {
            try {

                const data = await getPortfolioById(id);

                console.log(data);

                setPortfolio(data);

            } catch (error) {

                console.error(error);

            } finally {

                setLoading(false);

            }
        }

        fetchDetail();

    }, [id]);

    if (loading) {
        return (
            <div className="container mt-5 text-center">
                <h3>Loading...</h3>
            </div>
        );
    }

    if (!portfolio) {
        return (
            <div className="container mt-5 text-center">
                <h3>Data tidak ditemukan</h3>
            </div>
        );
    }

    return (
        <div>

            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">

                <div className="container">

                    <Link
                        className="navbar-brand fw-bold"
                        to="/"
                    >
                        My Portfolio
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div
                        className="collapse navbar-collapse"
                        id="navbarNav"
                    >
                        <ul className="navbar-nav ms-auto">

                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/"
                                >
                                    Home
                                </Link>
                            </li>

                        </ul>
                    </div>

                </div>

            </nav>

            {/* Hero */}
            <div className="bg-light py-5 shadow-sm">

                <div className="container text-center">

                    <h1 className="fw-bold">
                        Detail Portfolio
                    </h1>

                    <p className="text-muted">
                        Terima kasih sudah melihat project saya 🙌
                    </p>

                </div>

            </div>

            {/* Detail */}
            <div className="container mt-5">

                <div className="card border-0 shadow-lg overflow-hidden">

                    <div className="row g-0">

                        <div className="col-md-5 text-center bg-light p-4">

                            <img
                                src={
                                    portfolio.image ||
                                    "/image/cv.png"
                                }
                                alt={portfolio.title}
                                className="img-fluid rounded"
                                style={{
                                    maxHeight: "350px",
                                    objectFit: "cover"
                                }}
                            />

                        </div>

                        <div className="col-md-7">

                            <div className="card-body p-5">

                                <h2 className="fw-bold mb-3">
                                   <a href={portfolio.project_url} rel="noreferrer" target="_blank">{portfolio.title}</a> 
                                </h2>

                                <p className="text-muted">
                                    {portfolio.description}
                                </p>

                                <hr />

                                <h5 className="fw-bold mb-3">
                                    Technology
                                </h5>

                                <div className="mb-4">

                                    {portfolio.tech_stack?.map((tech, index) => (
                                        <span
                                            key={index}
                                            className="badge bg-primary me-2 mb-2 p-2"
                                        >
                                            {tech}

                                        </span>
                                    ))}

                                </div>

                                <div className="d-flex gap-3 flex-wrap">

                                    <Link
                                        to="/"
                                        className="btn btn-secondary"
                                    >
                                        ← Kembali
                                    </Link>

                                    <a
                                        href="https://wa.me/6281234567890"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-success"
                                    >
                                        Chat WhatsApp
                                    </a>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            <footer className="bg-dark text-light py-5">

                <div className="container text-center">

                    <h4 className="fw-bold mb-3">
                        Rifhandi
                    </h4>

                    <p className="text-muted">
                        Fullstack Developer • Backend • Frontend • Cloud
                    </p>

                    <div className="d-flex justify-content-center gap-3 flex-wrap mb-4">

                        <a
                            href="https://wa.me/6281927067602"
                            className="btn btn-success"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            WhatsApp
                        </a>

                        <a
                            href="https://github.com/muhammad-rifqi/"
                            className="btn btn-light"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            GitHub
                        </a>

                        <a
                            href="https://www.youtube.com/@muhammadrifqi9805"
                            className="btn btn-danger"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Youtube
                        </a>

                        <a
                            href="https://www.linkedin.com/in/muhammad-rifqy-004b47107"
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            LinkedIn
                        </a>

                    </div>

                    <hr />

                    <p className="mb-0">
                        © 2026 Copyright by Rifhandi
                    </p>

                </div>

            </footer>

            {/* Floating WhatsApp */}
            <a
                href="https://wa.me/6281927067602"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: "fixed",
                    width: "60px",
                    height: "60px",
                    bottom: "20px",
                    right: "20px",
                    backgroundColor: "#25D366",
                    color: "#fff",
                    borderRadius: "50%",
                    textAlign: "center",
                    fontSize: "30px",
                    boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textDecoration: "none"
                }}
            >
                💬
            </a>

        </div>
    );
}

export default PortfolioDetail;